import { CampaignManagement } from "@/components/admin/CampaignManagement";

export default function BannersPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Commercial Banner Management</h2>
        <p className="text-muted-foreground">Manage advertising campaigns and banner displays</p>
      </div>
      <CampaignManagement />
    </div>
  );
}
